import React from 'react';
import './App.css';
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import Header from './Components/Header';
import HeroSection from './Components/HeroSection';
import HeroSection1 from './Components/HeroSection1';
import UseCasesHero from './Components/UseCasesHero';
import CardSection from './Components/CardSection';
import Solution from './Components/Solution';
import CardContent from './Components/CardContent';
import TemplateSection from './Components/TemplateSection/Templates';
import Faq from './Components/Faq';
import Footer from './Components/FooterSection/Footer';
import MainWhatsApp from './Components/Why_WhatsApp/MainWhatsApp';
import HeroSectionScroll from './Components/HeroSectionScroll';
import GridCardSection from './Components/GridCardSection';
import BlogCardSection from './Components/BlogCardSection/BlogCardSection';
import CertificateCard_Section from './Components/CertificatedCard_Section/CertificateCard_Section';
import IntegrationSection from './Components/IntegrationSection/IntegrationSection';
import StackCard from './Components/StackCard_Scroll/StackCard';
import AboutUs from './Components/AboutUsPage/AboutUs';

// import the new page component (Product section)
// whatsapp marketing
import WhatsAppMarketing from './Components/NavSection_Dropdown/Products/Whatsapp Marketing/WhatsAppMarketing';
import Why_WpMarketing from './Components/NavSection_Dropdown/Products/Whatsapp Marketing/Why_WpMarketing';
import How_WpMarketing from './Components/NavSection_Dropdown/Products/Whatsapp Marketing/How_WpMarketing';
import WhatsAppCampaign from './Components/NavSection_Dropdown/Products/Whatsapp Marketing/WhatsAppCampaign ';
import WhatsAppPricing from './Components/NavSection_Dropdown/Products/Whatsapp Marketing/WhatsAppPricing';
import OurClints from './Components/NavSection_Dropdown/Products/Whatsapp Marketing/OurClints';
import CustemorStory from './Components/NavSection_Dropdown/Products/Whatsapp Marketing/CustemorStory';
import WhyChoose from './Components/NavSection_Dropdown/Products/Whatsapp Marketing/WhyChoose';
import WpMarketing_Faq from './Components/NavSection_Dropdown/Products/Whatsapp Marketing/WpMarketing_Faq';

//whatsapp ads
import WhatsAppAds from "./Components/NavSection_Dropdown/Products/WhatsApp Ads/WhatsAppAds";
import Product from "./Components/NavSection_Dropdown/Products/WhatsApp Ads/Products";
import Ads from "./Components/NavSection_Dropdown/Products/WhatsApp Ads/Ads";
import Flow from "./Components/NavSection_Dropdown/Products/WhatsApp Ads/Flow";
import Demo from "./Components/NavSection_Dropdown/Products/WhatsApp Ads/Demo";
import Comparison from "./Components/NavSection_Dropdown/Products/WhatsApp Ads/Comparison";
import Testimonials from "./Components/NavSection_Dropdown/Products/WhatsApp Ads/Testimonials";
import FAQ from "./Components/NavSection_Dropdown/Products/WhatsApp Ads/FAQ.jsx";
import CtaBanner from "./Components/NavSection_Dropdown/Products/WhatsApp Ads/CtaBanner.jsx";


//whatsapp chatboat
import WhatsApp_Chatbot from './Components/NavSection_Dropdown/Products/WhatsApp Chatbot/WhatsApp_Chatbot';
import Our_Clints from './Components/NavSection_Dropdown/Products/WhatsApp Chatbot/Our_Clints';
import CardMenu_Section from './Components/NavSection_Dropdown/Products/WhatsApp Chatbot/CardMenu_Section';
import Build_Chatboat from './Components/NavSection_Dropdown/Products/WhatsApp Chatbot/Build_Chatboat';
import Benefits_WPChatbot from './Components/NavSection_Dropdown/Products/WhatsApp Chatbot/Benefits_WPChatbot';
import CustemorSection from './Components/NavSection_Dropdown/Products/WhatsApp Chatbot/CustemorSection';
import Wp_Features from './Components/NavSection_Dropdown/Products/WhatsApp Chatbot/Wp_Features';
import WpChatbot_Faq from './Components/NavSection_Dropdown/Products/WhatsApp Chatbot/WpChatbot_Faq';


//whatsapp forms
import WhatsAppForms from './Components/NavSection_Dropdown/Products/WhatsApp Forms/WhatsAppForms';
import Our_Clients from './Components/NavSection_Dropdown/Products/WhatsApp Forms/Our_Clients';
import What_WhatsAppForm from './Components/NavSection_Dropdown/Products/WhatsApp Forms/What_WhatsAppForm';
import Wp_Usecase from './Components/NavSection_Dropdown/Products/WhatsApp Forms/Wp_Usecase';
import Usecases from './Components/NavSection_Dropdown/Products/WhatsApp Forms/Usecases';
import CustomerSection from './Components/NavSection_Dropdown/Products/WhatsApp Forms/CustomerSection';
import WpForm_Faq from './Components/NavSection_Dropdown/Products/WhatsApp Forms/WpForm_Faq';


//whatsapp broadcast
import Whatsapp_Broadcast from './Components/NavSection_Dropdown/Products/WhatsApp Broadcast/Whatsapp_Broadcast';
import OurClients from './Components/NavSection_Dropdown/Products/WhatsApp Broadcast/OurClients';
import Wp_Feature from './Components/NavSection_Dropdown/Products/WhatsApp Broadcast/Wp_Feature';
import Benefits_WpBroadcast from './Components/NavSection_Dropdown/Products/WhatsApp Broadcast/Benefits_WpBroadcast';
import How_WpBroadcast from './Components/NavSection_Dropdown/Products/WhatsApp Broadcast/How_WpBroadcast';
import BusinessSection from './Components/NavSection_Dropdown/Products/WhatsApp Broadcast/BusinessSection';
import WpBroadcast_Faq from './Components/NavSection_Dropdown/Products/WhatsApp Broadcast/WpBroadcast_Faq';


//whatsapp Link & QR
import QR_HeroSection from './Components/NavSection_Dropdown/Products/WhatsApp Link QR/QR_HeroSection';
import Use_QRGenerate from './Components/NavSection_Dropdown/Products/WhatsApp Link QR/Use_QRGenerate';
import WPLink_Connector from './Components/NavSection_Dropdown/Products/WhatsApp Link QR/WPLink_Connector';

//pricing
import PricingPage from './Components/PricingPage/PricingPage';


function App() {
  return (
    <Router>
      <Header />

      <Routes>
        {/* Home */}
        <Route
          path="/"
          element={
            <>

              <HeroSection />
              {/* <HeroSection1 /> */}
              <GridCardSection />
              <MainWhatsApp />
              <HeroSectionScroll />
              <StackCard />
              {/* <Solution /> */}
              {/* <CardContent /> */}
              <CardSection />
              <TemplateSection />
              <BlogCardSection />
              <IntegrationSection />
              <Faq />

            </>
          }
        />

        {/* Use Cases */}
        <Route path="/usecases" element={<UseCasesHero />} />

        {/* About Us page */}
        <Route path="/aboutus" element={<AboutUs />} />

        {/* Pricing page */}
        <Route path="/pricing" element={<PricingPage />} />

        {/* Products -  WhatsApp Marketing page */}
        <Route
          path="/whatsapp-marketing"
          element={
            <>
              <WhatsAppMarketing />
              <Why_WpMarketing />
              <How_WpMarketing />
              <OurClints />
              <CustemorStory />
              <WhyChoose />
              <WpMarketing_Faq />

            </>
          }
        />

        {/* Products -  WhatsApp Ads page */}
        <Route
          path="/click-to-wa-ads"
          element={
            <>

              <WhatsAppAds />
              <Ads />
              <Product />
              <Demo />
              <Flow />
              <Comparison />
              <Testimonials />
              <CtaBanner />
              <FAQ />
            </>
          }
        />

        {/* Products -  WhatsApp Chatboat page */}
        <Route
          path="/whatsapp-chatbots"
          element={
            <>
              <WhatsApp_Chatbot />
              <Build_Chatboat />
              <Wp_Features />
              <CardMenu_Section />
              <Our_Clints />
              <Benefits_WPChatbot />
              <CustemorSection />
              <WpChatbot_Faq />

            </>
          }
        />

        {/* Products -  WhatsApp Forms page */}
        <Route
          path="/whatsapp-forms"
          element={
            <>
              <WhatsAppForms />
              <Our_Clients />
              <What_WhatsAppForm />
              <Wp_Usecase />
              <CustomerSection />
              <Usecases />
              <WpForm_Faq />
            </>
          }
        />

        {/* Products -  WhatsApp Broadcast page */}
        <Route
          path="/whatsapp-broadcast"
          element={
            <>
              <Whatsapp_Broadcast />
              <OurClients />
              <Wp_Feature />
              <Benefits_WpBroadcast />
              <How_WpBroadcast />
              <BusinessSection />
              <WpBroadcast_Faq />
            </>
          }
        />

        {/* Products -  WhatsApp Link & QR page */}
        <Route
          path="/whatsapp-link-qr"
          element={
            <>
              <QR_HeroSection />
              <Use_QRGenerate />
              <WPLink_Connector />
            </>
          }
        />

      </Routes>

      {/* Certificate */}
      <CertificateCard_Section />
      {/* Footer */}
      <Footer />
    </Router>
  );
}

export default App;


